import Link from 'next/link';

import { IconButton } from '@/components/core';
import LogoLia from '@/svgs/liateam-logo.svg';

const LogoFooter: React.FC = () => {
  return (
    <>
      <IconButton
        style={{ width: 'fit-content' }}
        aria-label="Logo Lia"
        bgColor={'transparent'}
        _hover={{ bgColor: 'transparent' }}
        icon={
          <Link href={'/'}>
            <LogoLia height={49} width={147} />
          </Link>
        }
      />
    </>
  );
};

export default LogoFooter;
